export default __webpack_public_path__ + "static/media/Graph_right.2c882154.svg";